import { createRoomPreviewOwner } from '@/lib/search'
import type { Room } from '@/services/cms'
import type { DeviceTypeWithAndroidIOS } from '@/types/configs'
import type { AvailableRecentWatchHistoryItem } from '@/types/recent-watch-history'
import { RoomStatus } from '@/types/room-status'
import type { AvailableWatchHistoryItem, NoAccessWatchHistoryItem } from '@/types/watch-history'

export function toWatchHistoryRoomInfo(
  item:
    | ((AvailableWatchHistoryItem | AvailableRecentWatchHistoryItem) &
        Pick<Room, 'is_selected' | 'is_exclusive' | 'is_top' | 'is_hot'>)
    | NoAccessWatchHistoryItem,
): Partial<Room> {
  if (item.status === RoomStatus.NoAccess) {
    return { title: item.title, hub_sid: item.hub_sid }
  }

  return {
    id: item.id,
    title: item.title,
    image: item.image,
    hub_sid: item.hub_sid,
    view_count: item.view_count,
    like_count: item.like_count,
    is_liked: item.is_liked,
    tags: item.tags,
    preferred_devices: item.preferred_devices as DeviceTypeWithAndroidIOS[] | undefined,
    vod_id: item.vod_id,
    vod_duration: item.vod_duration,
    vod_last_update_date: item.vod_last_update_date ?? undefined,
    first_public_date: item.first_public_date,
    last_updated_at: item.last_updated_at,
    owner: createRoomPreviewOwner(item),
    trailer_videos: item.trailer_videos ?? undefined,
    is_selected: item.is_selected,
    is_exclusive: item.is_exclusive,
    is_top: item.is_top,
    is_hot: item.is_hot,
  }
}
